import type { RefObject } from "react";
import { useCallback } from "react";

export function useAutosizeTextarea(
  textareaRef: RefObject<HTMLTextAreaElement | null>,
) {
  return useCallback(() => {
    const textarea = textareaRef.current;
    if (!textarea) return;
    textarea.style.height = "auto";
    textarea.style.height = `${textarea.scrollHeight}px`;
  }, [textareaRef]);
}
